// Single source of truth for public AdCast display subscription prices.
// Keep subscription UI and structured data aligned with these values.
export const PRICING = Object.freeze({
  firstDisplay: Object.freeze({ monthly: 12.99, yearly: 129.99 }),
  multiDisplay: Object.freeze({
    monthlyPriceForTwoDisplays: 19.99,
    monthlyPricePerAdditionalDisplay: 10,
    yearlyMonths: 10,
  }),
  trialDays: 30,
  includedStorageGb: 1,
});

export const getPriceBreakdown = (displayCount, billingPeriod) => {
  const displays = Math.max(1, Number.parseInt(displayCount, 10) || 1);
  const monthlyTotal = displays === 1
    ? PRICING.firstDisplay.monthly
    : PRICING.multiDisplay.monthlyPriceForTwoDisplays
      + ((displays - 2) * PRICING.multiDisplay.monthlyPricePerAdditionalDisplay);
  const yearlyTotal = displays === 1
    ? PRICING.firstDisplay.yearly
    : monthlyTotal * PRICING.multiDisplay.yearlyMonths;

  return {
    displays,
    monthlyTotal,
    yearlyTotal,
    yearlyMonthlyEquivalent: yearlyTotal / displays / 12,
    yearlySavings: monthlyTotal * 12 - yearlyTotal,
    total: billingPeriod === 'yearly' ? yearlyTotal : monthlyTotal,
  };
};

// Avoid binary floating-point edge cases such as 8.325 rendering as 8.32.
export const formatUsd = (value) => (
  Math.round((Number(value) + Number.EPSILON) * 100) / 100
).toFixed(2);
